<template>
    <form 
        @submit.prevent="submit" 
        class="form" 
        :class="{'form--loading': loading}">

        <notify
            icon="sport_finishing_flag"
            title="Bijna klaar"
            :text="notifyText"
            :show="errorInCheckboxes"
            :hide-after="10000"
            v-if="notifyText"
            @close="() => { errorInCheckboxes = false }" />

        <div class="grid-x grid-padding-x grid-padding-y">
            <div class="cell small-24 medium-12">
                <input-field 
                    :errors="errors" 
                    v-model="datamodel.user.first_name"
                    placeholder="Voornaam"
                    name="first_name"
                    v-validate="'required'"
                    :required="true"
                    label="Voornaam" />
            </div>
            <div class="cell small-24 medium-12">
                <input-field 
                    :errors="errors"
                    v-validate="'required'"
                    placeholder="Achternaam"
                    v-model="datamodel.user.last_name" 
                    name="last_name"
                    :required="true"
                    label="Achternaam" />
            </div>
            <div class="cell small-24 medium-12">
                <select-field 
                    :errors="errors"
                    v-model="datamodel.user.gender" 
                    name="gender"
                    :required="true"
                    v-validate="'required'"
                    label="Geslacht">
                    <option 
                        :value="null" 
                        selected>Je geslacht</option>
                    <option value="male">Jongen</option>
                    <option value="female">Meisje</option>
                </select-field>
            </div>
            <div class="cell small-24 medium-12">
                <date-field
                    :errors="errors" 
                    v-model="datamodel.user.date_of_birth"
                    v-validate="'required'"
                    :required="true"
                    placeholder="Je geboortedatum"
                    name="date_of_birth"
                    label="Geboortedatum"
                    :options="{maxDate: 'today', minDate: minAge, defaultDate: currentAge}" />
            </div>
            <div class="cell small-24">
                <radio-field 
                    :errors="errors" 
                    v-model="emailType"
                    :required="true"
                    label="E-mailadres"
                    :input-value="emailType"
                    :options="[{value: '0', name: 'Ik heb een eigen e-mailadres.'}, {value: '1', name: 'Ik heb geen eigen e-mailadres en gebruik het e-mailadres van mijn ouder/verzorger.'}]" />
            </div>
        </div>

        <div 
            class="grid-x grid-padding-x grid-padding-y" 
            v-if="emailType == '0'">
            <div class="cell">
                <input-field 
                    :errors="errors"
                    name="email"
                    :required="true"
                    v-validate="'required|email'"
                    v-model="datamodel.user.email"
                    placeholder="Je e-mailadres" />
            </div>
        </div>

        <div class="grid-x grid-padding-x grid-padding-y">
            <div class="cell">
                <password-field 
                    :errors="errors" 
                    v-model="datamodel.user.password" 
                    label="Wachtwoord"
                    :required="true"
                    v-validate="'required|min:6'"
                    name="password"
                    placeholder="Je wachtwoord" />
            </div>

            <div class="cell">
                <div class="form__panel">
                    <h3 class="h--black">E-mailadres van je ouder/verzorger <span class="required">*</span></h3>
                    <p>Op dit e-mailadres ontvangt ook je ouder/verzorger de nodige informatie over de IJSTIJD! activiteit die jij hebt gekozen.</p>
                    <input-field 
                        :errors="errors" 
                        v-model="datamodel.parent_email"
                        name="email_parent"
                        v-validate="'required|email'"
                        placeholder="E-mailadres van je ouder/verzorger" />
                </div>
            </div>
            <div class="cell">
                <ul class="inputlist">
                    <li>
                        <checkbox-field 
                            :errors="errors" 
                            v-model="parent_permission"
                            v-validate="'required:true'"
                            name="parent_permission">
                            Ik heb toestemming van mijn ouders.
                        </checkbox-field>
                    </li>
                    <li>
                        <checkbox-field 
                            :errors="errors"
                            v-model="av_accepted"
                            v-validate="'required:true'"
                            name="av_accepted">
                            Ik ga akkoord met de

                            <a
                                href="https://www.schaatsen.nl/disclaimer/"
                                target="_blank">algemene voorwaarden</a>

                            en het
                            
                            <a
                                href="https://www.schaatsen.nl/privacy-statement-ijstijd/"
                                target="_blank">privacybeleid</a>.
                        </checkbox-field>   
                    </li>
                </ul>
            </div>
            <div class="cell">
                <div class="cell">
                    <div class="btn-holder btn-holder--center">
                        <submit-field>
                            Inschrijven
                        </submit-field>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { mapActions } from 'vuex';
import { ScrollToError } from '@/helpers';
import moment from 'moment';
moment.locale('nl');
import Notify from '@/components/Notify.vue';

export default {
    inject: ['$validator'],
    data() {
        return {
            loading: false,
            emailType: '0',
            parent_permission: false,
            av_accepted: false,
            errorInCheckboxes: false,
            datamodel: {
                parent_email: null,
                user: {
                    first_name: null,
                    last_name: null,
                    date_of_birth: null,
                    password: null,
                    email: null,
                }
            },
        };
    },
    components: {
        Notify,
    },
    computed: {
        notifyText() {
            if(this.errors.first('av_accepted') && this.errors.first('parent_permission')) {
                return 'Accepteer de algemene voorwaarden en het privacybeleid en zorg dat je toestemming van je ouder/verzorger hebt.';
            } else if(this.errors.first('av_accepted')) {
                return 'Accepteer de algemene voorwaarden en het privacybeleid.';
            } else if(this.errors.first('parent_permission')) {
                return 'Heb je wel toestemming van je ouder/verzorger? Vink dit dan aan.';
            }

            return '';
        },
        minAge() {
            return moment().subtract(12, 'years')._d;
        },
        currentAge() {
            return moment().subtract(10, 'years')._d;
        }
    },
    methods: {
        ...mapActions({
            'register': 'sportid/register'
        }),
        submit() {
            if(this.emailType === '1') {
                this.datamodel.user.email = this.datamodel.parent_email;
            }

            this.$validator.validateAll().then((success) => {
                if(this.errors.first('av_accepted') || this.errors.first('parent_permission')) {
                    this.errorInCheckboxes = true;
                } else {
                    this.errorInCheckboxes = false;
                }

                if(success) {
                    this.loading = true;

                    this.register(this.datamodel).then(() => {
                        this.$router.push({
                            name: 'redeem_newsletter',
                            params: this.$route.params,
                            query: this.$route.query,
                        });
                    }, ({data}) => {
                        if(data.status === 422) {
                            Object.entries(data.errors).forEach((item) => {
                                if(item[0] === 'email' && this.emailType === '1') {
                                    this.errors.add({
                                        field: 'email_parent',
                                        msg: item[1][0]
                                    });
                                }

                                this.errors.add({
                                    field: item[0],
                                    msg: item[1][0]
                                });
                            });

                            ScrollToError(this.$el);
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
                } else {
                    ScrollToError(this.$el);
                }
            });            
        },
    },
};
</script>
